import MovingBorderMenu from "./Menu/MovingBorderMenu";
import Menus from "./Menu/Menus";
import 'jquery-confirm'
import OP3Dashboard from "./OP3Dashboard";
import OP3WallopSlider from "./Slider/WallopSlider";
import OP3MovingImage from "./Element/MovingImage";
import OP3Dialog from "./General/Dialog";

class OP3General {
    constructor() {
        this.menus = null;
        this.pages = {};
        this.mainMenu = this.createMovingBorderMenu('.op3-main-menu');

        this.pages.dashboard = new OP3Dashboard();
        this['jQueryInit']();
    }

    get dialogOptions() {
        return OP3Dialog.dialogOptions;
    }

    /**
     * jQuery initialization
     */
    ['jQueryInit']() {
        let _this = this;
        let $ = jQuery;

        $(document).ready(() => {
            _this.menus = new Menus($);
        });
    }

    /**
     * Creates Moving Border Menu
     *
     * @param {string} selector
     * @param {boolean} preventClick
     * @return {MovingBorderMenu}
     */
    createMovingBorderMenu(selector, preventClick = false) {
        return new MovingBorderMenu(selector, preventClick);
    }

    /**
     * Creates Wallop Slider
     *
     * @param {string} sliderSelector
     * @param {jQuery} $
     * @param {boolean} autoResize
     * @return {OP3WallopSlider}
     */
    createWallopSlider(sliderSelector, $, autoResize = false) {
        return new OP3WallopSlider(sliderSelector, $, autoResize)
    }

    /**
     * Creates image that is scrolling down when image is bigger then container
     *
     * @param {string} selector
     * @param {jQuery} $
     * @return {OP3MovingImage}
     */
    createMovingImage(selector, $) {
        return new OP3MovingImage(selector, $);
    }
}

export default OP3General;

window.OP3General = new OP3General();


// WEBPACK FOOTER //
// ./resources/assets/js/OP3General.js